/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: dashboard
 * (C) Copyright IBM Corp. 2013, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'../../view/features/content/contentViewDom/api/impl/ContentViewDomImpl',
	'underscore',
	'jquery',
	'../../app/util/EventChainLocal',
	'./LayoutHelper',
	'../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../api/deprecated/CanvasAPI',
	'../../canvas/DeprecatedCanvas',
	'./authoring/interaction/Controller',
	'./authoring/interaction/strategy/Common',
	'../../lib/@waca/core-client/js/core-client/utils/Deferred',
	'../../lib/@waca/core-client/js/core-client/utils/ClassFactory'
], function(Class, ContentViewDomImpl, _, $, EventChainLocal, LayoutHelper, APIFactory, DeprecatedCanvasAPI, DeprecatedCanvas, Controller, CommonInteraction, Deferred, ClassFactory) {

	let LayoutController = null; // declaration

	LayoutController = Class.extend([], {

		init: function(options) {
			LayoutController.inherited('init', this, arguments);

			this.dashboardApi = options.dashboardApi;

			this._settings = this.dashboardApi.getFeature('DashboardSettings');
			const optionsSetting = this._settings.get('applicationSettings').options;
			this.config = optionsSetting && optionsSetting.config || {};

			this.contentFeatureLoader =  options.contentFeatureLoader;
			//TODO - to be remove after refactoring
			this.services = options.services;


			// TODO - end

			this.dashboardApi = options.dashboardApi;
			this.canvas = options.canvas;

			this.transaction = this.dashboardApi.getFeature('Transaction');
			this.contentTypeRegistry = this.dashboardApi.getFeature('ContentTypeRegistry');

			this.isAuthoring = this.dashboardApi.getMode() === 'authoring';

			this.id = _.uniqueId('layoutController');
			this.$el = options.$el;
			this.viewsMap = {};
			this.boardModel = options.boardModel;
			this.interactionControllerDfd = new Deferred();

			this.widgetLoader = options.widgetLoader;

			this.canvasController = options.canvasController;
			this.logger = this.dashboardApi.getFeature('Logger');
			this.glass = this.dashboardApi.getFeature('Glass');
			this.colorsService = this.dashboardApi.getFeature('Colors');
			if (this.colorsService) {
				this.colorsService.on('theme:changed', this.onThemeChange, this);
				this.colorsService.on('colorSet:changed', this.onColorSetChanged, this);
			}

			this.topLayoutModel = this.boardModel.layout;
			this.topLayoutModel.on('change:layoutPositioning', this._onLayoutPositioning, this);

			this._setupViewModules(options.layoutExtensions || {});
			this.canvasNotifier = options.canvasNotifier;
			this.interactionController = null;
			this.eventRouter = options.eventRouter;
			if (this.eventRouter) {
				this.eventRouter.on('canvas:selectWidget', this.selectWidget, this);
				this.eventRouter.on('canvas:deselectWidget', this.deselectWidget, this);
				this.eventRouter.on('scene:select', this.deselectAllWidgets, this);
				this.eventRouter.on('scene:next', this.deselectAllWidgets, this);
				this.eventRouter.on('scene:previous', this.deselectAllWidgets, this);
			}

			this.gatewayUrl = options.gatewayUrl;
			this.cdnUrl = options.cdnUrl;
			this._init();

			// Create the deprecated canvas
			// This is the canvas implementation for all the deprecated APIs
			// It is is created in here because the deprecated APIs depend on the layout controller and the layout and widget views
			// The non deprecated canvas API is created earlier in the boardLoader.
			this.deprecatedCanvas = new DeprecatedCanvas(this.dashboardApi, this.boardModel, this.canvasController, this, this.widgetLoader);

		},

		initialize: function() {
			return this.pageReady;
		},

		getDeprecatedCanvas: function() {
			// Merge the public canvas api with the deprecated one
			// Eventually , the layout controller will stop creating the deprecated one onces all deprecated method are no longer used

			if (!this.mergedCanvasAPI){
				this.mergedCanvasAPI = _.extend(this.deprecatedCanvas.getAPI(), this.canvas);
			}
			return this.mergedCanvasAPI;
		},

		_setupViewModules: function(layoutExtensions) {
			this.consumeViews = layoutExtensions.consumeViews || {};
			this.authoringViews = layoutExtensions.authoringViews || {};

		},

		/** If the layout has 'subviews' (ie. tabs or scenes), return the id of the current one. */
		getCurrentSubViewId: function() {
			let topView = this.getView(this.topLayoutModel.id).view;
			return topView.getSelectedSubViewId();
		},

		/** If the layout has 'subviews' (ie. tabs or scenes), return the title of the current one. */
		getCurrentSubViewTitle: function() {
			let topView = this.getView(this.topLayoutModel.id).view;
			return topView.getSelectedSubViewTitle();
		},

		_animationHelper: function(el, property, value, duration ){
			return new Promise((resolve) => {
				let transitionEndCallback = () => {
					el.style.transition = 'none';
					el.removeEventListener('transitionend', transitionEndCallback);
					resolve();
				};
				el.addEventListener('transitionend', transitionEndCallback);
				el.style.transition = property + ' ' + duration + 'ms';
				el.style[property] = value;

				// fail safe
				Promise.delay(duration + 100).then(transitionEndCallback);
			});
		},

		_init: function() {
			this._interactionControllerCreationPromise = this._createInteractionController().then(function() {
				let topView = this._getTopViewElement()[0];
				if (topView){
					$(topView).toggleClass('authoringMode', this.isAuthoring);
				}
			}.bind(this));

			$(window).on('resize.layoutController' + this.id, this.onResize.bind(this));

			// set global right-click context menu suppression
			this.fnOnContextMenu = this.onContextMenu.bind(this);
			window.oncontextmenu = this.fnOnContextMenu;
		},

		createLayoutModules: function() {
			this.pageReady = Promise.all([
				this._interactionControllerCreationPromise,
				this.createLayoutModule(this.topLayoutModel.id).then((layout) => {
					if (layout) {
						return layout.renderContent();
					}
				})]);
			// Mark the page when the render is complete for the top layout and all widget underneath it.
			this.onPageRenderComplete = this.whenPageRenderComplete();
			this.onPageRenderComplete.then(() => {
				let topLayoutView = this.getTopLayoutView();
				if (topLayoutView){
					topLayoutView.$el.attr('data-render', 'renderComplete');
				}

			});
		},

		_getInteractionControllerInteractionModules: function() {
			let paths;
			if (this.isAuthoring && !this.isEventGroupMode) {
				paths = [
					'dashboard-core/js/dashboard/layout/authoring/interaction/strategy/Authoring'
				];
			} else {
				paths = [];
			}
			return Promise.all(
				paths.map(path => ClassFactory.loadModule(path))
			);
		},

		_shouldEnableInteractions: function() {
			return this.dashboardApi.getAppConfig('enableInteractions') !== false;
		},

		_createInteractionController: function() {
			if (!this._shouldEnableInteractions() || this.interactionController) {
				return Promise.resolve();
			}

			return this._loadInteractionControllerConfig()
				.then(selectionOptions => {
					const interactionController = new Controller({
						// TODO - to be removed after refactoring
						services: this.services,
						// TODO - end to be removed

						config: this.config,
						dashboardAPI: this.dashboardApi,
						toolbarConfig:  this.dashboardApi.getAppConfig('toolbar'),
						transaction: this.transaction,
						canvas: this.canvas,
						boardModel: this.boardModel,
						layoutController: this,
						eventRouter: this.eventRouter,
						$el: this.$el,
						gatewayUrl: this.gatewayUrl,
						cdnUrl: this.cdnUrl,

						selectionOptions: selectionOptions
					});
					// TODO temporary code to register interaction controller needed by the widget action features, e.g. GroupAction
					this.dashboardApi.getFeature('internal').registerDashboardSvc('InteractionController.internal', interactionController);

					this.defaultInteractions = [
						new CommonInteraction(this.logger, this.dashboardApi)
					];

					this._setInteractionController(interactionController);

					return this._updateInteractionControllerInteractions();
				});
		},

		_setInteractionController: function(controller) {
			this.interactionController = controller;
			this.interactionControllerDfd.resolve(controller);
		},

		getInteractionController: function() {
			return this.interactionControllerDfd.promise;
		},

		_loadInteractionControllerConfig: function() {
			const {
				deselectionSelector
			} = this.dashboardApi.getAppConfig('selection') || {};

			if (deselectionSelector) {
				return new Promise((resolve, reject) => {
					require([deselectionSelector], resolve, reject);
				}).then(module => {
					return {
						deselectionSelector: module
					};
				});
			}
			return Promise.resolve();
		},

		/**
		 * Set the interaction controller strategy (authoring, consumption, event group).
		 *
		 * @return {Promise} Promise to be resolved when the strategy has been set
		 */
		_updateInteractionControllerInteractions: function() {
			if (!this.interactionController) {
				return Promise.resolve();
			}

			return this._getInteractionControllerInteractionModules()
				.then((Interactions) => {
					const interactions = Interactions.map((Interaction) => new Interaction(this.logger));
					const allInteractions = this.defaultInteractions.concat(interactions);

					return this.interactionController.applyInteractions(allInteractions).then(() => {
						this.dashboardApi.getFeature('.LifeCycleManager').invokeLifeCycleHandlers('dashboard.layout.interactions.ready');
					});
				});
		},

		/**
		 * Moves to consume mode
		 *
		 * Removes authoring functionality that was added to the all consume views.
		 * Views associated with static widgets remain (they are not deleted)
		 */
		changeToConsumeMode: function() {
			this.isAuthoring = false;
			this.isEventGroupMode = false;

			return this._updateInteractionControllerInteractions()
				.then(() => {
					this.removeAuthorModeFromLayout(this.topLayoutModel.id);

					this._getTopViewElement()
						.removeClass('authoringMode')
						.removeClass('eventGroupMode');
				});
		},

		/**
		 * Removes author behavior to specified view
		 *
		 * @param id - layout identifier
		 */
		removeAuthorModeFromLayout: function(id) {
			let layoutModel = this.topLayoutModel.findModel(id);
			let view = $('#' + layoutModel.id, this.$el)[0];

			if (view && view._layout && view._layout.authorHelper) {
				view._layout.authorHelper.destroy();
				view._layout.authorHelper = undefined;
				if (view._layout.authorViewManager) {
					view._layout.authorViewManager.destroy();
					view._layout.authorViewManager = undefined;
				}
			}

			if (layoutModel.items) {
				for (let i = 0, iLen = layoutModel.items.length; i < iLen; i++) {
					this.removeAuthorModeFromLayout(layoutModel.items[i].id);
				}
			}
		},

		/**
		 * Attaches author behavior
		 *
		 * @param options - {canvasNotifier: notifier obj}
		 * @return promise to indicate when move to authoring is complete
		 */
		changeToAuthorMode: function(options) {
			this.isAuthoring = true;
			this.isEventGroupMode = false;
			this.canvasNotifier = options.canvasNotifier;

			//start with top layout
			return this.addAuthorModetoLayout(this.topLayoutModel.id, null)
				.then(() => {
					this._getTopViewElement()
						.addClass('authoringMode')
						.removeClass('eventGroupMode');

					// initialize interaction controller strategy
					return this._updateInteractionControllerInteractions();
				});
		},

		changeToEventGroupMode: function() {
			this.isAuthoring = true;
			this.isEventGroupMode = true;

			return this._updateInteractionControllerInteractions()
				.then(() => {
					this.removeAuthorModeFromLayout(this.topLayoutModel.id);

					this._getTopViewElement()
						.removeClass('authoringMode')
						.addClass('eventGroupMode');
				});
		},

		_getTopViewElement: function() {
			return this.$el.find('#' + this.topLayoutModel.id);
		},

		/**
		 * Attaches author behavior to specified view
		 *
		 * @param id - layout identifier
		 * @param parentLayout - parent view for layout being moved to author
		 * @return promise to indicate when move to authoring is complete
		 */
		addAuthorModetoLayout: function(id, parentLayout) {
			let layoutModel = this.topLayoutModel.findModel(id);
			let node = $('#' + this.modelIdToNodeId(id), this.$el)[0];
			let pageLayoutView = node && node._layout;


			if (!pageLayoutView && !this._hasConsumeLayout(layoutModel)) {
				// the layout view does not exist. This is the case for static widget and layouts like group layout.
				// Create layout module will take care of create the layout view and the author helper.
				return this.createLayoutModule(id, parentLayout).then(layout => layout.renderContent());
			}

			if (!pageLayoutView || pageLayoutView.authorHelper) {
				// The view has not been created yet (delayed creation) or authoring has already been enabled for this view.
				return Promise.resolve();
			}

			let options = {
				//TODO - remove after refactoring
				services: this.services,
				// TODO - end remove

				config: this.config,
				logger: this.logger,
				glass: this.glass,
				settings: this._settings,
				canvas: this.canvas,
				dashboardApi: this.dashboardApi,
				model: layoutModel,
				parentLayout: parentLayout,
				layoutController: this,
				canvasNotifier: this.canvasNotifier,
				consumeView: pageLayoutView,
				widgetChromeEventRouter: pageLayoutView.widgetChromeEventRouter,
				eventRouter: this.eventRouter
			};
			let modules = this._getLayoutModule(layoutModel, options);

			return ClassFactory
				.loadModule(modules.sAuthorHelper)
				.then(PageLayoutAuthor => {
					// The authoring view will set the authorHelper reference of the consumeView to itself
					new PageLayoutAuthor(options);

					pageLayoutView.renderContent();

					//process children layouts
					let layoutModels = layoutModel.items;
					if (layoutModels && !pageLayoutView.preventAuthoringForChildren) {

						let promises = [];
						for (let i = 0, iLen = layoutModels.length; i < iLen; i++) {
							promises.push(this.addAuthorModetoLayout(layoutModels[i].id, pageLayoutView));
						}
						return Promise.all(promises);
					}
				});
		},

		getView: function(modelId) {
			return this.viewsMap[modelId];
		},

		markViewAsReady(view){
			if (this.viewsMap[view.id]) {
				this.viewsMap[view.id].viewReadyDeferred.resolve(view);
			}
		},

		/**
		 * Create an instance of the layout module
		 *
		 * @param {string} pageId - layout page id
		 * @param {View} parentLayout - parent view for layout being moved to author
		 * @param {any} [additionalWidgetData] - data to be passed to the widget when the layout is created.
		 *
		 * @return {Promise} Promise to indicate when the creation is complete
		 */
		createLayoutModule: function(pageId, parentLayout, additionalWidgetData) {
			let existingView = this.viewsMap[pageId] && this.viewsMap[pageId].view;
			if (existingView) {

				/* No need to create the view. We have an existing view associated with the layout id that is being created.
				This might happen after the following scenario:
				- Create layout model A
				- Create layout model B
				- Move layout model A to be child of B.


				The view creation is asynchronous. This means that the process of the creation of A & B will start
				but the move operation will happen before the view are created so the changes will not be reflected in the views.
				so we end up with creating the view A and the view B with another instance of View A.

				The scenario that will cause this is the following:
				- group 2 objects.
				- delete 1 of the grouped objects.
				- This will delete the object and remove the group
				- undo the change.

				 */
				let promise = this.viewsMap[pageId].viewReady;
				if (parentLayout) {
					promise.then(function () {
						let nodeId = this.modelIdToNodeId(pageId);
						this.viewsMap[pageId].view.parentLayout = parentLayout;
						$(parentLayout.domNode).find('#' + nodeId).replaceWith(this.viewsMap[pageId].view.domNode);
					}.bind(this));
				}
				return promise;
			}

			let deferred = new Deferred();

			let page = this.topLayoutModel.findModel(pageId);
			let options = {
				// TODO - remove after refactoring
				services: this.services,
				config: this.config,
				// TODO - end remove
				canvas: this.canvas,
				logger: this.logger,
				glass: this.glass,
				settings: this._settings,
				content: this.canvas.getContent(pageId),
				dashboardApi: this.dashboardApi,
				eventRouter: this.eventRouter,
				model: page,
				layoutController: this,
				canvasNotifier: this.canvasNotifier,
				parentLayout: parentLayout,
				additionalWidgetData: additionalWidgetData,
				contentFeatureLoader: this.contentFeatureLoader
			};


			let layoutModules = this._getLayoutModule(page, options);

			let sPageLayout = layoutModules.sPageLayout;
			let sAuthorHelper = layoutModules.sAuthorHelper;
			this.viewsMap[pageId] = {
				viewReadyDeferred: deferred,
				viewReady: deferred.promise
			};

			let promise;
			if (sPageLayout) {
				let modules = ['dashboard-core/js/app/EventRouter'];
				if (sAuthorHelper) {
					modules.push(sAuthorHelper);
				}

				promise = Promise.all([
					ClassFactory.loadModule(sPageLayout),
					Promise.all(
						modules.map(module => ClassFactory.loadModule(module))
					)
				]).then(function (Modules) {

					// update the parent layout in the options
					// there is a case where by the time we load the module, the parent has changed
					// Today, this is  the case of undo a delete of an object that belongs to a group.
					// the operation will create the object with the page as a parent, then move it to the group object
					const parentModel = options.model.getParent();
					if (parentModel){
						options.parentLayout = this.getLayoutView(parentModel.id);
					}

					let PageLayout = Modules[0];
					let EventRouter = Modules[1][0];
					let AuthorHelper = Modules[1][1];

					if (page.type === 'widget' || this.contentTypeRegistry.isTypeRegistered(page.type)) {
						options.widgetChromeEventRouter = new EventRouter();
					}
					let pageLayout = new PageLayout(options);
					if (AuthorHelper) {
						options.consumeView = pageLayout;
						// The authoring view will set the authorHelper reference of the consumeView to itself
						new AuthorHelper(options);
					}
					this.viewsMap[pageId].view = pageLayout;
					pageLayout.setLoading(true);

					return pageLayout;
				}.bind(this));
			} else {
				promise = Promise.resolve();
			}
			return promise;
		},

		removeView: function(view) {
			if(this.viewsMap) {
				delete this.viewsMap[view.model.id];
			}
		},


		_hasConsumeLayout: function(layoutSpec) {
			let consumeLayoutView = null;
			if (layoutSpec.type === 'widget' || layoutSpec.type === 'appwidget') {
				// check the widget if it has a defined layout view
				const widgetModel = this.boardModel.getWidgetModel(layoutSpec.id);
				const type = widgetModel && widgetModel.type;
				consumeLayoutView = this.widgetLoader.widgetRegistry[type] && this.widgetLoader.widgetRegistry[type].layoutConsumeView;
			} else {
				// Non widget type always have a layout view
				consumeLayoutView = true;
			}
			return !!consumeLayoutView;
		},


		_getLayoutModule: function(layoutSpec, options) {
			let sPageLayout;
			let sPageLayoutAuthor;
			let modules = null;

			if (layoutSpec.type === 'widget' || layoutSpec.type === 'appwidget') {
				modules = this._getWidgetLayoutModule(layoutSpec, options);
			} else {
				sPageLayout = this.consumeViews[layoutSpec.type];
				if (!sPageLayout) {
					// layout views like group do not have consumption views.
					// Use the base view for them in authoring mode
					sPageLayout = 'dashboard-core/js/dashboard/layout/views/LayoutBaseView';
				}
				// else {
				// TODO: what do we do if we don't have a page layout?
				// }

				sPageLayoutAuthor = this.isAuthoring ? (this.authoringViews[layoutSpec.type] || 'dashboard-core/js/dashboard/layout/authoring/views/LayoutBaseView') : undefined;
				modules = {
					sPageLayout: sPageLayout,
					sAuthorHelper: sPageLayoutAuthor
				};
			}

			return modules;
		},
		_getWidgetLayoutModule: function(layoutSpec, options) {
			let widgetModel = this.boardModel.getWidgetModel(layoutSpec.id);
			options.widgetModel = widgetModel;
			let type = widgetModel && widgetModel.type;
			options.widgetRegistry = this.widgetLoader.widgetRegistry[type];

			let sPageLayout = options.widgetRegistry && options.widgetRegistry.layoutConsumeView;
			let sPageLayoutAuthor = null;
			if (this.isAuthoring) {
				if (!sPageLayout) {
					//static widgets don't have a view associated in consume mode
					//use base widget view for them
					sPageLayout = 'dashboard-core/js/dashboard/layout/views/Widget';
				}
				if (options.widgetRegistry) {
					sPageLayoutAuthor = options.widgetRegistry.layoutAuthoringView;
				}
			}

			return {
				sPageLayout: sPageLayout,
				sAuthorHelper: sPageLayoutAuthor
			};
		},

		onThemeChange: function(payload) {
			if (payload.value !== payload.prevValue) {
				this.onResize({ reRender: true });
			}
			this.eventRouter.trigger('properties:refreshPane', {
				focusSelector: '.dropDowntheme'
			});
		},

		_onLayoutPositioning: function(payload) {
			if (payload.sender === 'UndoRedoController') {
				this.eventRouter.trigger('properties:refreshPane');
			} else {
				let layoutModels = this.topLayoutModel.findDescendantsWithType('genericPage');

				for (let layoutModel of layoutModels) {
					layoutModel.set(
						{
							layoutPositioning: payload.value
						},
						{
							payloadData: payload.data,
							sender: this.id
						}
					);
				}
			}
		},

		onColorSetChanged: function () {
			this.colorsService.makeSureColorIsValidInModel({
				model: this.topLayoutModel,
				propertyName: 'css',
				offset: 2,
				valuePrefix: 'fill-'
			});
			this.colorsService.makeSureColorIsValidInModel({
				model: this.topLayoutModel,
				propertyName: 'fillColor',
				offset: 2
			});

			// Don't use the same offset as the fillColor or our tab text color will end up being the same color as the background
			this.colorsService.makeSureColorIsValidInModel({
				model: this.topLayoutModel,
				propertyName: 'tabTextColor',
				offset: 1
			});
			this.colorsService.makeSureColorIsValidInModel({
				model: this.topLayoutModel,
				propertyName: 'tabSelectedLineColor',
				offset: 1
			});
			this.colorsService.makeSureColorIsValidInModel({
				model: this.topLayoutModel,
				propertyName: 'tabBackgroundColor',
				offset: 1
			});
		},

		onResize: function(renderOptions) {
			if (this.$el.is(':visible')) {
				// We only resize if the view is visible.
				let topLayoutView = this.getTopLayoutView();
				if (topLayoutView && topLayoutView.onResize) {
					topLayoutView.onResize(renderOptions);
				}
			}
		},

		getTopLayoutView: function() {
			return this.getLayoutView(this.topLayoutModel.id);
		},

		getTopLayoutViewWhenReady: function() {
			return this.getLayoutViewWhenReady(this.topLayoutModel.id);
		},

		getSelectedNodes: function() {
			return this.interactionController.getSelectedNodes();
		},

		getSelectedWidgets: function() {
			const selectedLayout = this.boardModel.getSelectedLayout();
			const layout = this.topLayoutModel.findModel(selectedLayout);

			return layout ? layout.getSelectedWidgets() : [];
		},

		getLayoutContentContainer: function() {
			return LayoutHelper.getLayoutContentContainer(this.topLayoutModel.id, null, this.dashboardApi);
		},

		getLayoutContentContainerForDropTarget(dropTargetNode) {
			return LayoutHelper.getLayoutContentContainerForDropTarget(dropTargetNode, this.topLayoutModel, this.dashboardApi);
		},

		/**
		 *  Find the last visible page to insert. For example, if you have this hierarchy of pages: Block/Tab/Absolute.
		 *  It will return the Absolute of the selected tab.
		 *  Will return the first availabe drop zone if a template.
		 */
		getLastVisiblePage: function() {
			return LayoutHelper.getLastVisiblePage(this.topLayoutModel.id, null, this.dashboardApi);
		},

		setPreferredAddOptions: function(addOptions) {
			return LayoutHelper.setPreferredAddOptions(addOptions, this.topLayoutModel, this.dashboardApi);
		},


		setPreferredLocation: function(addOptions) {
			return LayoutHelper.setPreferredLocation(addOptions);
		},

		destroy: function(event) {


			// Ensure we are not removing the context menu if has been set by some other class.
			if (this.fnOnContextMenu && window.oncontextmenu === this.fnOnContextMenu) {
				this.fnOnContextMenu = null;
				window.oncontextmenu = null;
			}

			$(window).off('resize.layoutController' + this.id);

			if (this.colorsService) {
				this.colorsService.off('theme:changed', this.onThemeChange, this);
			}
			if (this.topLayoutModel) {
				this.topLayoutModel.off('change:layoutPositioning', this._onLayoutPositioning, this);
				// destroy the top layout view.
				this.destroyLayoutView(this.topLayoutModel.id, event);
			}

			if (this.interactionController) {
				this.interactionController.destroy();
			}

			if (this.deprecatedCanvas) {
				this.deprecatedCanvas.destroy();

			}

			for (var prop in this) {
				// clear everything referenced by this object in case someone is still holding on to it.
				if (Object.prototype.hasOwnProperty.call(this, prop)) {
					delete this[prop];
				}
			}

			this._isDestroyed = true;
		},

		destroyLayoutView: function(layoutId, event) {
			let viewEntry = this.viewsMap[layoutId];
			viewEntry && viewEntry.view && viewEntry.view.destroy(event);
		},

		/**
		 *  Return the node id that maps to the given model id
		 * @param modelId
		 * @returns
		 */
		modelIdToNodeId: function(modelId) {
			return LayoutHelper.modelIdToNodeId(modelId);
		},

		/**
		 *  Return the model id for a given node id
		 * @param nodeId
		 * @returns
		 */
		nodeIdToModelId: function(nodeId) {
			return LayoutHelper.nodeIdToModelId(nodeId);
		},

		/**
		 * Return a promise that will be resolved when the layout view is created and ready
		 * At this point, the widget module (if available) might not be loaded and ready yet.
		 *
		 * @param modelId - id or array of ids
		 *
		 * @returns {Promise} promise to be fulfilled when the layout is ready
		 */
		layoutReady: function(modelId) {
			if (this._isDestroyed) {
				return Promise.reject('Layout Controller destroyed');
			}
			let idArray = modelId;
			if (!_.isArray(idArray)) {
				idArray = [modelId];
			}

			let views = _.pick.apply(_, [this.viewsMap].concat(idArray));

			return Promise.all(_.pluck(views, 'viewReady'))
				.then(function() {
					let layout;
					if (_.isArray(modelId)) {
						layout = _.pluck(views, 'view');
					} else {
						layout = views[modelId] && views[modelId].view;
					}
					return layout;
				});
		},

		/**
		 * Selects all layouts (groups, widgets, etc...) in the array of ids
		 * @param layoutIds Array of ids
		 * @param event The original event
		 */
		selectLayouts: function(layoutIds, event) {
			let promises = [];
			let selectionHandler = this.interactionController.selectionHandler;
			_.each(layoutIds, function(layoutId) {
				let promise = this.whenWidgetRenderComplete(layoutId).then(function(layout) {
					selectionHandler.selectNode(layout.domNode, event);
				});
				promises.push(promise);
			}.bind(this));

			return Promise.all(promises);
		},

		/**
		 * Return a promise that will be resolved when the widget module is created and ready
		 *
		 * @param modelId - id
		 *
		 */
		widgetReady: function(modelId) {
			return this.layoutReady(modelId)
				.then(function(layout) {
					if (this.viewsMap[modelId] && this.viewsMap[modelId].view && this.viewsMap[modelId].view.widgetReady) {
						return this.viewsMap[modelId].view.widgetReady()
							.then(function(/* widgetAPI */) {
								return layout;
							});
					} else {
						// Some widget in consume mode do not have modules.
						return layout;
					}
				}.bind(this));
		},

		/**
		 * Return a promise that will be resolved when the widget is rendered
		 *
		 * @param modelId - id
		 *
		 */
		whenWidgetRenderComplete: function(modelId) {
			return this.layoutReady(modelId)
				.then(function(layout) {
					if (this.viewsMap[modelId] && this.viewsMap[modelId].view && this.viewsMap[modelId].view.whenRenderComplete) {
						return this.viewsMap[modelId].view.whenRenderComplete()
							.then(function() {
								return layout;
							});
					} else {
						// Some widget in consume mode do not have modules.
						return layout;
					}
				}.bind(this));
		},

		/**
		 * Wait until page render is complete
		 *
		 * @param {Layout} pageLayout - page layout
		 * @return {Promise} promise resolved when the page render is complete
		 */
		whenPageRenderComplete: function(pageLayout) {
			return this.layoutReady(this.topLayoutModel.id)
				.then(function() {
					let widgets = (pageLayout || this.topLayoutModel).findDescendantsWithType('widget');
					let promises = [];
					_.each(widgets, function(widget) {
						promises.push(this.whenWidgetRenderComplete(widget.id));
					}, this);

					return Promise.all(promises);
				}.bind(this));
		},

		/**
		 * Return a promise that will be resolved when the widget is rendered
		 *
		 * @param modelId - identifier of widget the message is sent on behalf of
		 * @param multiselect - flag indicating whether the selection is for multiple widgets
		 * @param showContextBar - flag indicating whether to show the default context bar
		 *
		 */
		selectWidget: function(event) {
			let modelId = event.modelId;
			let multiselect = event.multiselect;
			let showContextBar = event.showContextBar;

			return this.widgetReady(modelId)
				.then(function(layout) {
					//widget param in widgetReady function is also passed in (can be used at a later time)
					if (!multiselect) {
						this.deselectAllWidgets();
					}

					let selectionHandler = this.interactionController.selectionHandler;

					//this prevents the context bar from appearing
					let eventChainLocal = new EventChainLocal(event);

					if (!showContextBar) {
						eventChainLocal.setProperty('preventDefaultContextBar', true);
					}

					if (selectionHandler) {
						selectionHandler.selectNode(layout.domNode, event);
					}
				}.bind(this));
		},

		deselectAllWidgets: function() {
			if (this.interactionController) {
				this.interactionController.selectionHandler.deselectAll();
			}
		},

		deselectWidget: function(event) {
			let modelId = event.modelId;
			let layoutView = this.viewsMap[modelId] && this.viewsMap[modelId].view;
			let selectionHandler = this.interactionController.selectionHandler;

			if(!selectionHandler) {
				return Promise.resolve();
			}
			if(layoutView && layoutView.domNode) {
				return Promise.resolve(selectionHandler.deselectNode(layoutView.domNode));
			} else {
				return this.widgetReady(modelId)
					.then(function(layout) {
						selectionHandler.deselectNode(layout.domNode);
					}.bind(this));
			}
		},

		moveLayout: function(updateArray) {
			const transactionToken = this.transaction.startTransaction();

			updateArray.forEach((info) => {
				this.canvas.moveContent(info.parentId, [ info.id ], transactionToken);
			});
			this.transaction.endTransaction(transactionToken);
		},

		// NOTE:
		// getLayoutView and getLayoutViewWhenReady should be combined into one.
		// `getLayoutViewWhenReady` - was created as part of the conversion to bluebird and the operation became async instead of sync.
		//
		// We can't guarantee that the view is ready so to be safe, one should always call getLayoutViewWhenReady.
		// Should be fixed as part of a bigger revamp
		//
		getLayoutViewWhenReady: function(modelId) {
			let viewEntry = this.viewsMap[modelId];

			if (!viewEntry) {
				// check if it is in the model and attempt to create it
				let model = this.topLayoutModel.findModel(modelId);
				if (model && model.getParent() === this.topLayoutModel){
					// the page might have been delayed and not create.. ensure it is created.
					const topView = this.viewsMap[this.topLayoutModel.id];
					if (topView && topView.view && topView.view.renderChild){
						return topView.view.renderChild(modelId, true).then(() => {
							viewEntry = this.viewsMap[modelId];
							if (!viewEntry) {
								return Promise.resolve(null);
							}
							return viewEntry.viewReady;
						});
					}
				}
				return Promise.resolve(null);
			}

			return viewEntry.viewReady;
		},

		getLayoutView: function(modelId) {
			let viewEntry = this.viewsMap[modelId];
			return viewEntry && viewEntry.view;
		},

		onContextMenu: function(event) {
			let nodeName = event.target.nodeName;
			let $target = $(event.target);
			return nodeName === 'INPUT' ||
				nodeName === 'TEXTAREA' ||
				$target.attr('contenteditable') === 'true' ||
				$target.closest('[contenteditable="true"]').length ? true : false;
		},

		getInteractionProperties: function() {
			return this.interactionController.getInteractionProperties();
		},

		hasMaximizedWidget: function() {
			let viewIds = Object.keys(this.viewsMap);
			for (let i = 0; i < viewIds.length; i++) {
				let view = this.getLayoutView(viewIds[i]);
				if (view && view.widgetAPI && view.widgetAPI.isWidgetMaximized && view.widgetAPI.isWidgetMaximized()) {
					return true;
				}
			}

			return false;
		},

		/**
		 * @param layoutWidgetId The layout id for the widget being processed.
		 * @param {boolean} noPageContextMerge  if <tt>true</tt> the pageContext will not be merged into the Widget Model
		 * @returns the widgetModel which is attached to the pin for this layoutWidgetId.
		 *			The widgetModel for pinning can be overridden (or returned) by a widget
		 *			if it implements the 'getWidgetModelForPinning' API. Otherwise, the model is returned from the board spec.
		 */
		getLayoutWidgetModel: function(layoutWidgetId, noPageContextMerge) {
			let widgetObj = this.widgetLoader.getWidget(layoutWidgetId);
			return (widgetObj && widgetObj.getWidgetModelForPinning && !noPageContextMerge) ?
				widgetObj.getWidgetModelForPinning() :
				this.boardModel.getWidgetModel(layoutWidgetId);
		}

	});

	return LayoutController;
});
